import { RootState } from 'store'

export const all = (state: RootState) => state.user
export const avatar = (state: RootState) => state.user.avatar
